import(/* webpackMode: "eager", webpackExports: ["BlocksRenderer"] */ "/root/repo/client/node_modules/@strapi/blocks-react-renderer/dist/BlocksRenderer.mjs");
;
import(/* webpackMode: "eager" */ "/root/repo/client/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/app/(public)/sportsbooks/slider.tsx");
;
import(/* webpackMode: "eager" */ "/root/repo/client/src/app/(public)/sportsbooks/styles.module.css");
;
import(/* webpackMode: "eager" */ "/root/repo/client/src/components/primitives/button.tsx");
